export default "__VITE_ASSET__DfxwNkOO__"